export default "__VITE_ASSET__BW3F0ql7__"